// src/components/AuthPages.jsx
import React from 'react';
import { ThemeProvider, Box, CircularProgress, Button } from '@mui/material';
// import SoftBox from 'components/SoftBox';
// import SoftTypography from 'components/SoftTypography';
import theme from 'assets/theme';
import SoftBox from 'components/SoftComponents/SoftBox';
import SoftTypography from 'components/SoftComponents/SoftTypography';
import LogoutButton from 'components/Buttons/LogoutButton';
import SoftButton from 'components/SoftComponents/SoftButton';

export function LoadingPage({ message = "Loading..." }) {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
        background: linearGradient(gradients.dark.main, gradients.dark.state),
        height: '100%', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1200, overflow: 'hidden'
      })}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh">
          <CircularProgress color="light" />
          <SoftTypography variant="button" fontWeight="medium" mt={2} color="light">
            {message}
          </SoftTypography>
        </SoftBox>
      </Box>
    </ThemeProvider>
  );
}

export function RedirectingPage({ targetUrl }) {
  console.log(targetUrl)
  React.useEffect(() => {
    if (targetUrl) {
      const timer = setTimeout(() => {
        window.location.href = targetUrl;
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [targetUrl]);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
        background: linearGradient(gradients.dark.main, gradients.dark.state),
        height: '100%', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1200
      })}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh" p={3}>
          <SoftTypography variant="h4" color="white" mb={1}>
            Logging out...
          </SoftTypography>
          <SoftTypography variant="body2" color="light" mb={3}>
            You are being redirected.
          </SoftTypography>
          <CircularProgress color="light" size={28} />
        </SoftBox>
      </Box>
    </ThemeProvider>
  );
}

export function LoggedOutPage({ targetUrl }) {
  const loginUrl = targetUrl || window.location.origin;

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
          background: linearGradient(gradients.dark.main, gradients.dark.state),
          height: "100%",
          width: "100%",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 1200,
        })}
      >
        <SoftBox
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
          p={3}
        >
          <SoftTypography variant="h4" color="white" mb={1}>
            You have been logged out
          </SoftTypography>

          <SoftTypography variant="body2" color="light" mb={3} textAlign="center">
            Your session has ended.
          </SoftTypography>

          <SoftButton
            variant='gradient' color="light"
            onClick={() => {
              window.location.href = loginUrl;
            }}
          >
            Click here to login again
          </SoftButton>
        </SoftBox>
      </Box>
    </ThemeProvider>
  );
}

export function NotApprovedUserPage({ domainConfig }) {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
        background: linearGradient(gradients.dark.main, gradients.dark.state),
        height: '100%', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1200
      })}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh" p={3} textAlign="center">
          <SoftTypography variant="h3" color="white" mb={2}>
            Access Pending Approval
          </SoftTypography>
          <SoftTypography variant="body1" color="light" maxWidth="500px" mb={3}>
            Your identity was authenticated, but your user account has not yet been approved on this system.
          </SoftTypography>
          <SoftTypography variant="body2" color="light" opacity={0.8}>
            Please contact your system administrator to grant permissions for your domain account.
          </SoftTypography>
          <SoftTypography variant="body2" color="light" mt={2} opacity={0.8}>
            Wrong account?
          </SoftTypography>
          <LogoutButton>
            <SoftButton variant='gradient' fullWidth color="light">
              Log out
            </SoftButton>
          </LogoutButton>

        </SoftBox>
      </Box>
    </ThemeProvider>
  );
}


export function ForbiddenPage() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={({ palette: { gradients }, functions: { linearGradient } }) => ({
        background: linearGradient(gradients.dark.main, gradients.dark.state),
        height: '100%', width: '100%', position: 'fixed', top: 0, left: 0, zIndex: 1200
      })}>
        <SoftBox display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="100vh" p={3} textAlign="center">
          <SoftTypography variant="h2" color="light" mb={1}>
            403 - Forbidden
          </SoftTypography>
          <SoftTypography variant="body1" color="light" maxWidth="500px" mb={3}>
            You do not have authorization to view this resource.
          </SoftTypography>
        </SoftBox>
      </Box>
    </ThemeProvider>
  );
}